import { useState, useEffect } from 'react'
import { fetchConfigs } from '../utils/fetchConfigs'

type Configs = {
  LOWER_PERCENT: number
  UPPER_PERCENT: number
  HIGH_PERCENT: number
  MAX_PERCENT: number
  SURVEY_QUESTION: string
  JOB_SITE_CAPACITY: number
}

export const useGetConfigs = () => {
  const [configs, setConfigs] = useState<Configs | null>(null)
  const [loading, setLoading] = useState<boolean>(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    const getConfigs = async () => {
      try {
        const fetchedConfigs = await fetchConfigs()
        setConfigs(fetchedConfigs)
      } catch (err) {
        console.error('Error fetching configurations:', err)
        setError('Failed to fetch configurations')
      } finally {
        setLoading(false)
      }
    }

    getConfigs()
  }, [])

  return { configs, loading, error }
}
